"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorshSchema = exports.borshDeserialize = exports.borshSerialize = void 0;
const buffer_1 = require("buffer");
const BorshSchema_1 = require("./BorshSchema");
Object.defineProperty(exports, "BorshSchema", { enumerable: true, get: function () { return BorshSchema_1.BorshSchema; } });
const borsh_1 = require("borsh");
function borshSerialize(schema, data) {
    return buffer_1.Buffer.from((0, borsh_1.serialize)(schema.toSchema(), data));
}
exports.borshSerialize = borshSerialize;
function borshDeserialize(schema, buffer) {
    return (0, borsh_1.deserialize)(schema.toSchema(), buffer);
}
exports.borshDeserialize = borshDeserialize;
//# sourceMappingURL=index.js.map